import { Component, OnInit } from '@angular/core';
import { EngineeringService } from 'src/app/services/engineering/engineering.service';
import { Router, ActivatedRoute } from '@angular/router';
import { disableDebugTools } from '@angular/platform-browser';
import { NgForm } from '@angular/forms';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-purchaseheader',
  templateUrl: './purchaseheader.component.html',
  styleUrls: ['./purchaseheader.component.css']
})
export class PurchaseheaderComponent implements OnInit {
  data: any;
  pono: string;
  isUserSiteinc: boolean;
  isUserTransport: boolean;

  constructor(private engineeringservice: EngineeringService, private router: Router,
    private route: ActivatedRoute, private userService: UserService) {
    this.userService.isUserSiteinc.subscribe(
      value => {
        this.isUserSiteinc = value;
      }
    );
    this.userService.isUserTransport.subscribe(
      value => {
        this.isUserTransport = value;
      }
    );
  }

  ngOnInit() {
    this.getpurchaseheader();
  }
  getpurchaseheader() {
    debugger;
    this.engineeringservice.GetPurchaseOrderList().subscribe(
      data => {
        this.data = data;
        console.log(data);
        if(this.isUserTransport || this.isUserSiteinc)
        {
          this.data = this.data.filter(x => x.isTransporter == true);
        }
      }
    )

  }

  viewOrder(id) {
    debugger;
    //alert(id);
    this.router.navigate(['/viewpurchaseorder/' + id + '']);

    // this.engineeringservice.GetPurchaseline(id).subscribe(
    //   data => {
    //     this.data = data;
    //     console.log(data);
    //   })

  }
  transportDetails(id) {
    debugger;
    //alert(id);
    this.router.navigate(['/addtransportdtls/' + id + '']);
  }
  purchaseheadersearch(keyword) {
    this.engineeringservice.searchPurchase(keyword).subscribe(
      (data) => {
        this.data = data;
        console.log(data);
        if(this.isUserTransport || this.isUserSiteinc)
        {
          this.data = this.data.filter(x => x.isTransporter == true);
        }
      }
    );
  }
}
